import {Component, OnInit} from '@angular/core';
import {AppConfigService} from '../../../services/config/app-config.service';
import {TokenStorageService} from '../../../services/storage/token-storage.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-extrenal-api',
    templateUrl: './extrenal-api.component.html',
    styleUrls: ['./extrenal-api.component.css'],
    standalone: false
})
export class ExtrenalApiComponent implements OnInit {
  externalProjectId: string | undefined;
  env: string | null;


  constructor(appConfig: AppConfigService, tokenStorageService: TokenStorageService, private sanitizer: DomSanitizer) {
    this.env = tokenStorageService.getUserEnv();
    if (this.env == 'asia') {
      this.externalProjectId = appConfig.getAsiaConfig?.externalProjectId;
    } else {
      this.externalProjectId = appConfig.getMenaConfig?.externalProjectId;
    }
  }

  ngOnInit(): void {
  }

}
